import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Button,
  Typography,
  Box,
  CardMedia,
  Tabs,
  Tab,
  IconButton,
  Drawer,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import color from "../../../components/utils/Colors";
import {
  ChevronLeft,
  ChevronRight,
  Description,
  ExpandMore,
  Share,
  VideoLibrary,
} from "@mui/icons-material";
import OverviewTab from "./OverviewTab";
import QnsPaperTab from "./QnsPaperTab";
import ReviewTab from "./ReviewTab";
import RatingModal from "../../../components/modal/RatingModal";
import { useNavigate, useParams } from "react-router-dom";
import {
  getOneDataFromTable,
  getDataFromTable,
} from "../../../services/services";

const OpenCourse: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open1, setOpen1] = useState(false);

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const navigate = useNavigate();
  const { courseId } = useParams<{ courseId: string }>();

  const [course, setCourse] = useState<any>(null);
  const [contents, setContents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!courseId) return;

    setLoading(true);
    Promise.allSettled([
      getOneDataFromTable("course", courseId),
      getDataFromTable("courseContent", { courseId }),
    ])
      .then(([courseRes, contentRes]) => {
        if (courseRes.status === "fulfilled") {
          setCourse(courseRes.value?.data?.data || {});
        }
        if (contentRes.status === "fulfilled") {
          setContents(contentRes.value?.data?.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, [courseId]);

  return (
    <Box sx={{ pb: 4 }}>
      <Box
        sx={{
          position: "fixed",
          top: "125px",
          right: "0",
          zIndex: 1000,
        }}
      >
        <ChevronLeft
          onClick={handleOpen}
          sx={{
            border: "solid 1.5px",
            borderColor: color.borderColor,
            cursor: "pointer",
            color: color.firstColor,
            borderRadius: "40px",
            background: color.secondColor,
            boxShadow: 1,
            width: "auto",
            height: { xs: "26px", sm: "40px", md: "60px" },
          }}
        ></ChevronLeft>
      </Box>

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: "90%",
            maxWidth: "400px",
            height: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 20,
              right: 10,
              color: color.firstColor,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{ mt: 0, p: 4, pb: 3, pt: 3, background: color.secondColor }}
          >
            <Typography variant="h6" component="h2">
              Course Content
            </Typography>
          </Box>

          {loading ? (
            <Box sx={{ p: 2 }}>
              {[1, 2, 3].map((i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  height={60}
                  sx={{ mb: 1 }}
                />
              ))}
            </Box>
          ) : contents.length > 0 ? (
            contents.map((item, idx) => (
              <>
                {item.lectureDesc && (
                  <AccordionDetails sx={{ p: 0 }}>
                    <Box
                      onClick={() =>
                        navigate(`/course/${courseId}/lecture/${item.id}`)
                      }
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        padding: "10px 12px",
                        mx: 1,
                        mb: 1,
                        border: "1.5px solid",
                        borderColor: color.borderColor,
                        borderRadius: "8px",
                        cursor: "pointer",
                        transition: "background 0.15s, box-shadow 0.15s",
                        "&:hover": {
                          background: "rgba(46,10,87,0.05)",
                          boxShadow: "0 2px 8px rgba(46,10,87,0.08)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <Typography
                          sx={{
                            color: color.textColor,
                            fontWeight: 600,
                            fontSize: "13px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.lectureDesc}
                        </Typography>
                        <Box display="flex" gap={0.5} mt={0.5}>
                          <IconButton
                            size="small"
                            sx={{ color: color.firstColor, p: 0.3 }}
                          >
                            <VideoLibrary sx={{ fontSize: 16 }} />
                          </IconButton>
                          <IconButton
                            size="small"
                            sx={{ color: color.firstColor, p: 0.3 }}
                          >
                            <Description sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Box>
                      </Box>
                      <ChevronRight
                        sx={{
                          color: color.firstColor,
                          fontSize: 20,
                          flexShrink: 0,
                        }}
                      />
                    </Box>
                  </AccordionDetails>
                )}
              </>
            ))
          ) : (
            <Typography sx={{ p: 3, color: "gray" }}>
              No content available.
            </Typography>
          )}
        </Box>
      </Drawer>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          borderRadius: "40px",
          margin: 4,
          mb: 2,
          mt: 2,
          flexGrow: 1,
          width: "auto",
          border: "solid 1.5px",
          borderColor: color.borderColor,
          background: "rgba(241, 235, 249, 1)",
          px: { xs: 2, sm: 4, md: 6 },
          height: "60px",
        }}
      >
        <Button
          onClick={() => navigate(`/course/${courseId}`)}
          sx={{
            fontWeight: "bold",
            color: "rgba(46, 10, 87, 1)",
            textTransform: "none",
          }}
        >
          Exit Course
        </Button>
        <Box>
          <Button
            onClick={handleOpen1}
            sx={{
              fontWeight: "bold",
              color: "#001C31",
              borderColor: "#001C31",
              textTransform: "none",
            }}
          >
            {" "}
            <StarIcon /> Leave rating
          </Button>
          <RatingModal open={open1} handleClose={handleClose1} />
          <Button
            sx={{
              color: "rgba(46, 10, 87, 1)",
            }}
          >
            {" "}
            <Share />
          </Button>
        </Box>
      </Grid>

      <Container
        maxWidth="xl"
        sx={{
          minHeight: "100vh",
          backgroundColor: "transparent",
          px: { xs: 2, sm: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 4,
            height: { xs: "300px", sm: "400px", md: "600px" },
            background: "#808080ba",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {course?.shortVideo ? (
            <CardMedia
              component="video"
              controls
              src={process.env.REACT_APP_PUBLIC_BASE_URL + course.shortVideo}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <CardMedia
              component="img"
              image={
                process.env.REACT_APP_PUBLIC_BASE_URL + course?.coverImage ||
                course?.image ||
                "/assets/Video-img.png"
              }
              alt="Course Cover"
              sx={{
                backgroundColor: "#D9D9D9",
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}
        </Box>

        <Box sx={{ mb: 3 }}>
          {loading ? (
            <Skeleton width="50%" height={40} />
          ) : (
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{ color: color.textColor }}
            >
              {course?.title || course?.courseName || "Course Title"}
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            border: "2px solid",
            borderRadius: "40px",
            overflow: "hidden",
            borderColor: color.borderColor,
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            centered
            sx={{
              background: color.secondColor,
              mb: 0,
              color: "rgba(46, 10, 87, 1)",
              ".MuiTab-root": {
                textTransform: "none",
                margin: {
                  xs: "0px 0px",
                  sm: "0px 10px",
                },
                fontWeight: "bold",
                color: "gray",
                fontSize: {
                  xs: "10px",
                  sm: "16px",
                },
                padding: {
                  xs: "0px 0px",
                  sm: "8px 16px",
                },
                marginBottom: {
                  xs: "2px",
                  sm: "8px",
                },
                "&.Mui-selected": {
                  color: "rgba(46, 10, 87, 1)",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "rgba(46, 10, 87, 1)",
                height: "2px",
              },
              paddingTop: {
                xs: "0",
                sm: "0px",
                md: "6px",
              },
            }}
          >
            <Tab label="Overview" />
            <Tab label="Notes" />
            <Tab label="Question Papers" />
            <Tab label="Review" />
          </Tabs>
        </Box>
        {selectedTab === 0 && <OverviewTab course={course} />}
        {selectedTab === 2 && (
          <QnsPaperTab courseId={courseId!} contents={contents} />
        )}
        {selectedTab === 3 && <ReviewTab />}
      </Container>
    </Box>
  );
};

export default OpenCourse;
